import { useRef, useImperativeHandle, forwardRef } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { FocusTrap } from 'focus-trap-react';
import './InlinePopoverCard.scss';

export default forwardRef(function InlinePopoverCard(
  { overlay, children, placement = 'bottom', focusTrap = true },
  ref,
) {
  const overlayRef = useRef(null);

  const onWheel = () => {
    document.body.click();
  };

  const hide = () => {
    overlayRef.current?.hide();
  };

  useImperativeHandle(ref, () => ({
    hide: () => {
      hide();
    },
  }));

  const popover = (
    <Popover className="popover inline-popover-card" placement="bottom">
      {focusTrap ? (
        <FocusTrap focusTrapOptions={{ clickOutsideDeactivates: true }}>
          {overlay}
        </FocusTrap>
      ) : (
        overlay
      )}
    </Popover>
  );

  return (
    <OverlayTrigger
      trigger={'click'}
      overlay={popover}
      placement={placement}
      rootClose={true}
      id="inline-popover-card-id"
      onEntered={() => {
        document.querySelector('#app').addEventListener('wheel', onWheel);
      }}
      onExited={() => {
        document.querySelector('#app').removeEventListener('wheel', onWheel);
      }}
      ref={overlayRef}
    >
      {children}
    </OverlayTrigger>
  );
});
